import { NextPageContext } from 'next/dist/shared/lib/utils'
import { Store } from 'redux'
import {
  newOlympSearchSelectors,
  newOlympSearchThunks,
} from '@ucheba/store/olympiads-new/search'
import OlympiadsPage from './index'

OlympiadsPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store } = ctx
  const { dispatch, getState } = store

  await dispatch(newOlympSearchThunks.fetch({ ctx, data: { limit: 10 } }))

  const entity = newOlympSearchSelectors.entity(getState())

  const { seo } = entity || {}

  return {
    content: {
      seo: {
        title: seo?.title || 'Олимпиады для старшеклассников — Учёба.ру',
        description:
          seo?.description ||
          'На Учебе.ру мы собрали полный каталог всероссийских и вузовских олимпиад для старшеклассников, которые дают возможность поступить в вуз без ЕГЭ или получить льготы и дополнительные баллы при поступлении в вузы.',
      },
    },
  }
}

export default OlympiadsPage
